export default __webpack_public_path__ + "static/media/ipc-ing02.44fbd5d5.svg";